module.exports = __webpack_public_path__ + "img/x-circle.a70004d0.svg";